// WhatsApp buttons: plain wa.me links (the GTM tag "WhatsApp – Ref code +
// click ID" appends " Ref: XXXXXX" itself — never add a Ref here), each with
// data-wa-source, and a whatsapp_click push on tap.
import { market } from "./market";
import { track } from "./tracking";

export function waLink(text) {
  const base = `https://wa.me/${market().whatsapp}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

export function trackWhatsappClick(source, { step = null, location = null } = {}) {
  track({
    event: "whatsapp_click",
    wa_source: source,
    booking_step: step,
    booking_location: location,
  });
}
